<template>
  <div class="wapper">
    <div class="info-wapper">
      <div v-for="item in list" :key="item.title" class="list-item">
        <div class="title">{{item.title}}</div>
        <div class="small">{{item.contact}}</div>
        <div class="small">{{item.area}}</div>
        <template v-if="item.title === '上海'">
        <div class="small">联系电话：021-63800150</div>
        <div class="small">业务合作：13818799570 </div>
        <div class="small">专家投诉及建议：15601777440</div>
        </template>
      </div>
    </div>
    <Map class="map"/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          title: '上海',
          contact: 'contact.sho@kohlberg.cn',
          area: '上海市徐汇区虹桥路1号'
        }, {
          title: '成都',
          contact: 'contact.cdo@kohlberg.cn',
          area: '成都市锦江区下东大街199号'
        }
      ]
    }
  },
  components: {
    Map: () => import('@/components/map.vue')
  }
}
</script>

<style lang="stylus" scoped>
.wapper
  display flex
  justify-content center
  max-width 1200px
  margin 0 auto
  padding 0 60px

.list-item
  margin-bottom 40px

.title
  color #000000
  font-size 24px
  margin-bottom 20px

.small
  font-size 16px

.info-wapper
  padding-right 20px
  padding-top 60px
  flex 0 0 30%

.map
  width 100%
  height: 370px
  margin-bottom 60px

@media screen and (max-width: 700px) {
    .wapper {
      display block
      padding 0 30px
    }
    .map {
      width 100%
      height: 300px
    }
    .info-wapper {
      padding-right 20px
      padding-top 0px
      flex 0 0 30%
    }
}
</style>
